import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

// The server only accepts these names; "new" is a custom sub category that
// also needs its own name and code.
export const SUB_CATEGORY_TYPES = [
  { value: "hr", label: "HR" },
  { value: "assets", label: "Assets" },
  { value: "supplier", label: "Supplier" },
  { value: "distributor", label: "Distributor" },
  { value: "customer", label: "Customer" },
  { value: "expense", label: "Expense" },
  { value: "new", label: "New (custom)" },
];

export const typeLabel = (value) =>
  SUB_CATEGORY_TYPES.find((type) => type.value === value)?.label || value;

// Fields shared by the create and edit screens.
const SubCategoryForm = ({
  inputs,
  chartOfAccount,
  selectedAccount,
  onChange,
  onAccountChange,
  onSubmit,
  displayError,
  saving,
  submitLabel,
  savingLabel,
}) => {
  const isCustom = inputs.name === "new";

  return (
    <>
      <div className="coa-panel">
        <div className="coa-panel-head">
          <span>
            <i className="fa fa-sitemap me-2"></i>Sub Category Details
          </span>
          {inputs.name && (
            <span className="coa-pill coa-pill-dr">
              {typeLabel(inputs.name)}
            </span>
          )}
        </div>
        <div className="coa-panel-body">
          <div className="row">
            <div className="col-lg-6">
              <label>
                Chart of Account <i className="fa fa-star required"></i>
              </label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                name="acc_chart_of_account_id"
                options={chartOfAccount}
                value={selectedAccount}
                onChange={onAccountChange}
                placeholder="Select Chart of Account"
                isSearchable
              />
              <small className="coa-hint">
                The account this sub category tracks balances under.
              </small>
              {displayError("acc_chart_of_account_id")}
            </div>
            <div className="col-lg-6 mg-t-10 mg-lg-t-0">
              <label>
                Sub Category Type <i className="fa fa-star required"></i>
              </label>
              <select
                className="form-control"
                name="name"
                value={inputs.name || ""}
                onChange={onChange}
                data-required
              >
                <option value="">Select Type</option>
                {SUB_CATEGORY_TYPES.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
              <small className="coa-hint">
                Decides which party (staff, supplier, distributor…) ledger
                entries are linked to.
              </small>
              {displayError("name")}
            </div>
          </div>

          {isCustom && (
            <div className="row mg-t-18">
              <div className="col-lg-8">
                <label>
                  Custom Name <i className="fa fa-star required"></i>
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="new_name"
                  value={inputs.new_name || ""}
                  onChange={onChange}
                  placeholder="Name for this custom sub category"
                />
                {displayError("new_name")}
              </div>
              <div className="col-lg-4 mg-t-10 mg-lg-t-0">
                <label>
                  Code <i className="fa fa-star required"></i>
                </label>
                <input
                  type="text"
                  className="form-control coa-mono"
                  name="code"
                  value={inputs.code || ""}
                  onChange={onChange}
                />
                {displayError("code")}
              </div>
            </div>
          )}

          <div className="row mg-t-18">
            <div className="col-lg">
              <label>Remarks</label>
              <textarea
                className="form-control"
                name="remarks"
                rows="2"
                value={inputs.remarks || ""}
                onChange={onChange}
                placeholder="What this sub category is used for"
              />
              {displayError("remarks")}
            </div>
          </div>
        </div>
      </div>

      <div className="coa-panel">
        <div className="coa-panel-head">
          <span>
            <i className="fa fa-balance-scale me-2"></i>Opening Balance
          </span>
          <span className="coa-head-note">
            Only needed when carrying a balance forward
          </span>
        </div>
        <div className="coa-panel-body">
          <div className="row">
            <div className="col-lg-4">
              <label>Effective Date</label>
              <input
                type="date"
                className="form-control"
                name="effective_date"
                value={inputs.effective_date || ""}
                onChange={onChange}
              />
              {displayError("effective_date")}
            </div>
            <div className="col-lg-4 mg-t-10 mg-lg-t-0">
              <label>Opening Balance</label>
              <input
                type="number"
                step="0.01"
                className="form-control coa-num"
                name="opening_balance"
                value={inputs.opening_balance ?? ""}
                onChange={onChange}
                placeholder="0.00"
              />
              {displayError("opening_balance")}
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center">
        <Link to="/sub-category" className="btn btn-outline-secondary">
          Cancel
        </Link>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onSubmit}
          disabled={saving}
        >
          <i
            className={`fa ${saving ? "fa-spinner fa-spin" : "fa-send"} mg-r-10`}
          ></i>
          {saving ? savingLabel : submitLabel}
        </button>
      </div>
    </>
  );
};

export default SubCategoryForm;
